import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function makeSelectTableColumn(store) {
  return {
    selectTableColumn: function selectTableColumn(editor, tableId, selectedColumnIndex) {
      var cells = editor.getTableCells(tableId);
      var columnCount = getTableColumnCountForCells(cells);
      var selectedCells = cells.filter(function (_cell, i) {
        return i % columnCount === selectedColumnIndex;
      });
      var selectedCellKeys = selectedCells.map(function (cell) {
        return cell.key;
      });
      var selectedCellsCoords = editor.getCellsCoords(selectedCells);
      store.updateItem(store.getItem('lastFocusedTableId'), {});
      store.updateItem('lastFocusedTableId', tableId);
      store.updateItem(tableId, {
        selectedColumnIndex: selectedColumnIndex,
        selectedCellKeys: selectedCellKeys,
        selectedCellsCoords: selectedCellsCoords
      });
      return editor.snapshotSelection().withoutSaving(function () {
        return editor.deselect();
      });
    }
  };
}